import { Component, OnInit, AfterViewInit } from '@angular/core';

@Component({
     selector: 'app-lang-changer',
     templateUrl: './lang-changer.component.html',
     styleUrls: ['./lang-changer.component.scss'],
})
export class LangChangerComponent implements OnInit, AfterViewInit {
     langs = [
          {
               label: 'fr',
               title: 'French (FR)',
               lang: 'fr-fr',
               active: (window as any).app.lang.activatedLang === 'fr-fr',
          },
          {
               label: 'en',
               title: 'English (GB)',
               lang: 'en-gb',
               active: (window as any).app.lang.activatedLang === 'en-gb',
          },
          {
               label: 'es',
               title: 'Spanish',
               lang: 'es',
               active: (window as any).app.lang.activatedLang === 'es',
          },
          {
               label: 'ca',
               title: 'Catalan',
               lang: 'es-ca',
               active: (window as any).app.lang.activatedLang === 'es-ca',
          },
          {
               label: 'pt',
               title: 'Portuguese',
               lang: 'pt-pt',
               active: (window as any).app.lang.activatedLang === 'pt-pt',
          },
     ];
     selectedLang;
     constructor() {}

     ngOnInit() {
          const m = this.langs.find((i) => i.active);
          this.selectedLang = m && m.lang;
     }

     ngAfterViewInit() {}

     setLang($event) {
          this.selectedLang = $event;
          if (this.selectedLang) {
               localStorage.setItem('htz.lang', this.selectedLang);
               window.location.reload();
          }
     }
}
